module.exports = __webpack_public_path__ + "img/logoword2.d71f2491.png";